import React from "react";

import { InfoRowProps } from "../ProjectDetails.types.tsx";

import { ProjectDetailsLabel, ProjectDetailsLabelBold } from "../../Labels.tsx";

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  return (
    <div className="d-flex justify-content-between mb-1">
      <ProjectDetailsLabelBold>{label}</ProjectDetailsLabelBold>
      <ProjectDetailsLabel>{value}</ProjectDetailsLabel>
    </div>
  );
};

export default InfoRow;
